module.exports = __webpack_public_path__ + "static/media/Man.bcd19082.jpg";